import React from 'react'
import "react-datepicker/dist/react-datepicker.css";

function EditClientEnvironment({ ClientCompanyTypeData, sendDataToParent }) {

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...ClientCompanyTypeData,
      [name]: value
    });
  };
  

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">Client Company Type <span style={{ color: "red" }}>*</span></label>
          <input
            type="hidden"
            name="ClientCompanyTypeId"
            value={ClientCompanyTypeData.ClientCompanyTypeId ?? ""}
          />
          <input
            type="text"
            className="form-control"
            name="ClientCompanyTypeName"
            value={ClientCompanyTypeData.ClientCompanyTypeName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea 
              className="form-control h-100" 
              rows="5" 
              name="Description"
              value={ClientCompanyTypeData.Description ?? ""}
              onChange={handleChange}
            />
        </div>
      </div>
    </>
  )
}

export default EditClientEnvironment